import React from 'react';

import { useRecoilValue } from 'recoil';

import { blockDisplayHeader, customizedBlock, isReportState } from 'venn-state';

import { Block } from '../../components/core';

import { BenchmarkType } from '../../components/secondary/benchmark-type';
import { DefaultSubjects } from '../../components/secondary/subjects/default-subjects';

interface SensitivityAnalysisHeaderProps {
  id: string;
}

export const SensitivityAnalysisHeader = ({ id }: SensitivityAnalysisHeaderProps) => {
  const title = useRecoilValue(blockDisplayHeader(id));
  const isReport = useRecoilValue(isReportState);
  const { selectedMetrics, relativeToBenchmark, subHeader } = useRecoilValue(customizedBlock(id));

  return (
    <>
      <Block.HeaderTopContainer id={id}>
        <Block.Title>
          <Block.Headline id={id}>{title}</Block.Headline>
          {subHeader && <Block.SubHeadline id={id}>{subHeader}</Block.SubHeadline>}
        </Block.Title>
        <Block.Metadata id={id}>
          <BenchmarkType id={id} />
          {relativeToBenchmark && <Block.MetadataItem iconType="calculator">Relative to Benchmark</Block.MetadataItem>}
        </Block.Metadata>
      </Block.HeaderTopContainer>

      <DefaultSubjects
        id={id}
        metric={selectedMetrics[0] || ''}
        relativeToBenchmark={relativeToBenchmark}
        hideSubjectsRow={isReport} // TODO: Why is the subjects row hidden only for Sensitivity Analysis in Report Lab?
      />
    </>
  );
};
